import React, { useEffect, useState } from "react";
import { fetchNews } from "../services/api";
import TVChart from "../components/TVChart";

export default function NewsPage() {
  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const [activeTab, setActiveTab] = useState("news");

  useEffect(() => {
    if (activeTab === "news") {
      const load = async () => {
        setLoading(true);
        try {
          const results = await fetchNews({ page });
          if (results.length > 0) {
            setPosts((prev) => {
              // 如果是第一页，直接替换
              if (page === 1) {
                return results;
              }
              
              // 合并新旧数据
              const combined = [...prev, ...results];
              
              // 去重：根据URL或标题去重
              const uniquePosts = combined.filter((post, index, self) => {
                return index === self.findIndex(p => 
                  (p.url && post.url && p.url === post.url) || 
                  (p.title === post.title && p.publishedAt === post.publishedAt)
                );
              });
              
              // 按时间重新排序
              return uniquePosts.sort((a, b) => {
                const dateA = new Date(a.publishedAt);
                const dateB = new Date(b.publishedAt);
                return dateB - dateA; // 降序排列，最新的在前
              });
            });
          } else {
            setHasMore(false);
          }
        } catch (error) {
          console.error("Failed to fetch news:", error);
          setHasMore(false);
        }
        setLoading(false);
      };
      load();
    }
  }, [page, activeTab]);

  return (
    <div className="min-h-screen bg-[#0a1b58] text-white px-6 py-16">
      {/* Header */}
      <header className="flex flex-col md:flex-row justify-between items-center max-w-5xl mx-auto mb-12 gap-6">
        <h1 className="text-4xl font-serif font-semibold">Crypto Dashboard</h1>
        <div className="flex flex-col md:flex-row gap-4 items-center">
          <div className="flex gap-2">
            <button
              onClick={() => {
                setActiveTab("news");
                if (activeTab !== "news") {
                  // 切换到新闻标签时重置数据，确保获取最新内容
                  setPosts([]);
                  setPage(1);
                  setHasMore(true);
                }
              }}
              className={`px-4 py-2 rounded ${
                activeTab === "news"
                  ? "bg-white text-[#0a1b58]"
                  : "bg-gray-700 text-white"
              }`}
            >
              新闻
            </button>
            <button
              onClick={() => setActiveTab("market")}
              className={`px-4 py-2 rounded ${
                activeTab === "market"
                  ? "bg-white text-[#0a1b58]"
                  : "bg-gray-700 text-white"
              }`}
            >
              行情
            </button>
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="space-y-24">
        {activeTab === "news" &&
          posts.map((post, i) => (
            <article
              key={post.url || `${post.title}-${post.publishedAt}-${i}`}
              className="flex flex-col md:flex-row max-w-5xl mx-auto gap-10"
            >
              {/* 左侧：来源/时间 */}
              <div className="w-full md:w-1/3 text-sm text-gray-300">
                <p>{post.source || "Unknown Source"}</p>
                <p>{new Date(post.publishedAt).toLocaleDateString()}</p>
              </div>

              {/* 右侧：标题/正文 */}
              <div className="w-full md:w-2/3">
                {post.image && (
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-48 object-cover mb-4 rounded-lg"
                  />
                )}
                <h2 className="text-2xl font-serif font-bold mb-4">
                  {post.url ? (
                    <a
                      href={post.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:underline hover:text-blue-300"
                    >
                      {post.title}
                    </a>
                  ) : (
                    post.title
                  )}
                </h2>
                <p className="text-gray-200 leading-relaxed text-[17px]">
                  {post.description || "点击“阅读原文”查看完整内容。"}
                </p>
                {post.url && (
                  <a
                    href={post.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block mt-3 text-sm text-blue-400 underline hover:text-blue-200"
                  >
                    阅读原文 →
                  </a>
                )}
              </div>
            </article>
          ))}

        {activeTab === "news" && hasMore && (
          <div className="text-center mt-16">
            <button
              onClick={() => setPage((p) => p + 1)}
              className="px-6 py-2 bg-white text-[#0a1b58] font-bold rounded hover:bg-gray-200"
              disabled={loading}
            >
              {loading ? "加载中..." : "加载更多"}
            </button>
          </div>
        )}

        {activeTab === "market" && (
          <div className="max-w-6xl mx-auto text-center space-y-12">
            <div className="text-2xl font-serif font-semibold">实时行情（TradingView）</div>
            <div className="grid md:grid-cols-2 gap-12">
              <TVChart symbol="BINANCE:BTCUSDT" />
              <TVChart symbol="BINANCE:ETHUSDT" />
            </div>
          </div>
        )}

      </main>
    </div>
  );
}
